import { gql } from '@apollo/client';

export const FOOTER_CONTENT_QUERY = gql`
  query ($slug: String!) {
    page(slug: $slug) {
      id
      title
      content
    }
  }
`;
